import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const DeleteConfirmModal = ({ isOpen, onClose, onConfirm, item, isDeleting = false }) => {
  if (!isOpen || !item) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-500 flex items-center justify-center p-4">
      <div className="bg-card border border-border rounded-lg w-full max-w-md">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-border">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-error/10 rounded-lg flex items-center justify-center">
              <Icon name="AlertTriangle" size={20} className="text-error" />
            </div>
            <div>
              <h2 className="text-xl font-semibold text-foreground">Delete Item</h2>
              <p className="text-sm text-muted-foreground">This action cannot be undone</p>
            </div>
          </div>
          <Button
            variant="ghost"
            size="icon"
            onClick={onClose}
            iconName="X"
            disabled={isDeleting}
          />
        </div>

        {/* Content */}
        <div className="p-6 space-y-4">
          <p className="text-foreground">
            Are you sure you want to delete this inventory item?
          </p>
          
          <div className="bg-muted/50 rounded-lg p-4 space-y-2">
            <div className="flex items-center space-x-2">
              <Icon name="Package" size={16} className="text-muted-foreground" />
              <span className="font-medium text-foreground">{item.name}</span>
            </div>
            <div className="text-sm text-muted-foreground">
              <span className="font-mono">{item.sku}</span> • {item.category}
            </div>
            {item.currentStock > 0 && (
              <div className="flex items-center space-x-2 pt-2 border-t border-border mt-2">
                <Icon name="AlertCircle" size={16} className="text-warning" />
                <span className="text-sm text-warning">
                  Warning: This item has {item.currentStock} units in stock
                </span>
              </div>
            )}
          </div>

          <p className="text-sm text-muted-foreground">
            Deleting this item will permanently remove it from your inventory system. 
            All historical data and transactions related to this item will be preserved.
          </p>
        </div>

        {/* Actions */}
        <div className="flex items-center justify-end space-x-3 p-6 border-t border-border">
          <Button
            variant="outline"
            onClick={onClose}
            disabled={isDeleting}
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={onConfirm}
            loading={isDeleting}
            iconName="Trash2"
            iconPosition="left"
          >
            Delete Item
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;
